import { clsx } from "clsx";
import { Boxes, Building2, ListTree, type LucideIcon } from "lucide-react";
import { Link, useLocation, useParams } from "react-router";

import {
	type PermissionInput,
	usePermissions,
} from "@/hooks/use-permissions.ts";

interface SettingsTab {
	label: string;
	segment: string;
	icon: LucideIcon;
	permission?: PermissionInput;
	adminOnly?: boolean;
}

const tabs: SettingsTab[] = [
	{
		label: "Templates de Etapas",
		segment: "templates-de-etapas",
		icon: ListTree,
		permission: "stage_templates:list",
	},
	{
		label: "Canteiros",
		segment: "canteiros",
		icon: Boxes,
		permission: "worksites:list",
	},
	{
		label: "Conta",
		segment: "conta",
		icon: Building2,
		adminOnly: true,
	},
];

export function SettingsNav() {
	const { obra } = useParams();
	const { pathname } = useLocation();
	const { has, isAdmin } = usePermissions();

	return (
		<nav className="settings-nav">
			{tabs
				.filter(
					(tab) =>
						(!tab.permission || has(tab.permission)) &&
						(!tab.adminOnly || isAdmin),
				)
				.map((tab) => {
					const to = `/${obra}/configuracoes/${tab.segment}`;
					const active = pathname.startsWith(to);
					const Icon = tab.icon;
					return (
						<Link
							key={tab.segment}
							to={to}
							className={clsx("settings-nav__tab", active && "is-active")}
						>
							<Icon />
							{tab.label}
						</Link>
					);
				})}
		</nav>
	);
}
